var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleBulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18H8.22222M18 7V8.22222M27.7778 18H29M10.1778 10.1778L11.0333 11.0333M25.8222 10.1778L24.9667 11.0333M15.1889 24.1111H20.8111M14.3333 22.8889C13.3072 22.1193 12.5493 21.0464 12.1669 19.8221C11.7844 18.5979 11.7969 17.2843 12.2025 16.0675C12.6081 14.8507 13.3863 13.7924 14.4268 13.0424C15.4673 12.2925 16.7174 11.8889 18 11.8889C19.2826 11.8889 20.5327 12.2925 21.5732 13.0424C22.6137 13.7924 23.3919 14.8507 23.7975 16.0675C24.2031 17.2843 24.2156 18.5979 23.8331 19.8221C23.4507 21.0464 22.6928 22.1193 21.6667 22.8889C21.1895 23.3613 20.8302 23.9393 20.6178 24.5763C20.4055 25.2133 20.3461 25.8913 20.4444 26.5556C20.4444 27.2039 20.1869 27.8256 19.7285 28.284C19.2701 28.7425 18.6483 29 18 29C17.3517 29 16.7299 28.7425 16.2715 28.284C15.8131 27.8256 15.5556 27.2039 15.5556 26.5556C15.6539 25.8913 15.5945 25.2133 15.3822 24.5763C15.1698 23.9393 14.8105 23.3613 14.3333 22.8889Z",
    stroke: "#5560E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleBulbIcon);
export default __webpack_public_path__ + "static/media/purple-bulb-icon.4e46753bdd676e0bf293ff02eb3719d3.svg";
export { ForwardRef as ReactComponent };